import { Link } from "react-router-dom";
import { Plane, Train, PartyPopper, Briefcase, Map, ChevronRight } from "lucide-react";
import { useTheme } from "@/components/ThemeContext";
import ScrollReveal from "@/components/ScrollReveal";

const services = [
  { icon: Plane, title: "Transfer per Aeroporti", desc: "Collegamento diretto con gli aeroporti di Napoli, Salerno, Roma e principali aeroporti." },
  { icon: Train, title: "Transfer per Stazioni", desc: "Servizio puntuale da e per le stazioni ferroviarie. Vi accogliamo all'arrivo per un trasferimento senza pensieri." },
  { icon: Briefcase, title: "Business Travel", desc: "Viaggi di affari con massima puntualità. Comfort e riservatezza per i professionisti più esigenti." },
  { icon: PartyPopper, title: "Eventi e Cerimonie", desc: "Matrimoni, battesimi, comunioni, feste di compleanno, feste ed eventi aziendali. Eleganza e discrezione per i vostri momenti importanti." },
  { icon: Map, title: "Tour Personalizzati", desc: "Costiera Amalfitana, Pompei, Napoli e altro. Itinerari su misura per scoprire la Campania." },
];

function ServiceCard({ service, index }) {
  const { isDark } = useTheme();
  const Icon = service.icon;
  const colClass = index === 0 ? "md:col-span-8" : "md:col-span-4";

  return (
    <ScrollReveal delay={index * 0.1} className={`${colClass} group`}>
      <div className={`border p-8 md:p-10 h-full hover:border-[#C9A646]/50 hover:-translate-y-1 transition-all duration-500 ${isDark ? "bg-[#141414] border-white/5" : "bg-white border-black/5 shadow-sm"}`}>
        <Icon className="w-8 h-8 text-[#C9A646] mb-6" strokeWidth={1.5} />
        <h3 className={`text-xl font-medium mb-3 ${isDark ? "text-white" : "text-[#1A1A1A]"}`}>{service.title}</h3>
        <p className={`text-sm leading-relaxed mb-4 ${isDark ? "text-[#A1A1AA]" : "text-[#666]"}`}>{service.desc}</p>
        <Link to="/servizi" data-testid={`service-link-${index}`} className="inline-flex items-center gap-1 text-[#C9A646] text-sm hover:gap-2 transition-all duration-300">
          Scopri di più <ChevronRight className="w-4 h-4" strokeWidth={1.5} />
        </Link>
      </div>
    </ScrollReveal>
  );
}

export default function ServicesSection() {
  const { isDark } = useTheme();

  return (
    <section data-testid="services-section" className={`py-20 md:py-32 transition-colors duration-500 ${isDark ? "bg-[#0A0A0A]" : "bg-[#F5F0E8]"}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-[#C9A646] block mb-4">I Nostri Servizi</span>
          <h2 className={`text-2xl sm:text-3xl lg:text-4xl tracking-tight font-normal mb-16 ${isDark ? "text-white" : "text-[#1A1A1A]"}`}>
            Soluzioni di trasporto<span className="italic text-[#C9A646]"> d'eccellenza</span>
          </h2>
        </ScrollReveal>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          {services.map((service, i) => (
            <ServiceCard key={service.title} service={service} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
